import React from 'react';

function TermsConditionPage() {
    return <div>Terms & Condition Page</div>;
}

export default TermsConditionPage;
